<template>
  <div class="rb-auth-layout">
    <div class="rb-auth-shell">
      <AuthForm @afterLogin="afterLogin"/>
    </div>
    <AuthTestimonialPanel/>
  </div>
</template>
<script>
import AuthForm from "@/components/Auth/AuthForm";
import AuthTestimonialPanel from "@/components/Auth/AuthTestimonialPanel";

export default {
  name: 'AuthWindow',
  components: {AuthForm, AuthTestimonialPanel},
  methods: {
    afterLogin() {
      this.$emit('afterLogin')
    }
  }
}
</script>
